module.exports = __webpack_public_path__ + "images/404-a139677b84004eddb13863f995604073.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/404.png
// module id = ./client/assets/images/404.png
// module chunks = 86